/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
export function UrlMessage() {
    
    return (
        <div id="messageUrl" className="bg-orange-300 rounded-lg p-2 mb-2 text-base w-full border-2 border-red-700 shadow-lg transform">
            <p>To access this page later, please save this URL:</p>
            <a id="href" href="#" className="underline font-thin">Save this link</a>
        </div>

      
    )
  }